import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { Tag } from 'antd';
import { DeleteOutlined, UndoOutlined } from '@ant-design/icons';
import fetchUsers from '../../../services/apollo/func/fetch/fetchUsers';
import handleDeleteUser from '../../../services/apollo/func/handle/handleDeleleUser';
import handleRestoreUser from '../../../services/apollo/func/handle/handleRestoreUser';
import auth from '../../../utils/auth';
import NormalButton from '../../components/buttons/normalButton';

const ESIM_ASSIGNED_MESSAGE = 'cannot delete user: a card/eID is still assigned to this email address';

export const formatUsers = users => users.map(user => ({
  key: user.id,
  id: user.id,
  email: user?.email || '--',
  username: [user?.firstName, user?.lastName].filter(Boolean).join(' ') || '--',
  createdAt: user?.createdAt ? moment(user.createdAt).format('DD/MM/YYYY - HH:mm:ss') : '--',
  isDeleted: Boolean(user?.deletedAt),
}));

export const getSearchBy = () => [
  {
    label: 'email',
    value: 'email',
  },
  {
    label: 'name',
    value: 'name',
  },
];

export const getColumns = (onDeleteClick, onRestoreClick) => {
  const columns = [
    {
      title: 'Email address',
      dataIndex: 'email',
      key: 'email',
      render: (email, record) => (
        <>
          {email}
          {record.isDeleted && <Tag color="red" className="ml-8">Deleted</Tag>}
        </>
      ),
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Created on',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
  ];
  if (auth.isAdmin()) {
    columns.push({
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (_value, record) => (
        record.isDeleted ? (
          <NormalButton
            icon={<UndoOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onRestoreClick(record);
            }}
          />
        ) : (
          <NormalButton
            isDanger
            icon={<DeleteOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onDeleteClick(record);
            }}
          />
        )
      ),
    });
  }
  return columns;
};

const friendlyDeleteMessage = (message) => {
  if (message === ESIM_ASSIGNED_MESSAGE) {
    return `${message}. Unassign the eSIM/card from this account's Card Information page first.`;
  }
  return "Couldn't delete this account. Please try again or contact engineering.";
};

export const deleteCustomerAccount = async (userId) => {
  try {
    const result = await handleDeleteUser({ userId });
    if (!result?.isSuccess) {
      return { isSuccess: false, message: friendlyDeleteMessage(result?.message) };
    }
    return result;
  } catch (error) {
    return {
      isSuccess: false,
      message: friendlyDeleteMessage(error.message),
    };
  }
};

const RESTORE_FAILURE_MESSAGE = "Couldn't restore this account. Please try again or contact engineering.";

export const restoreCustomerAccount = async (userId) => {
  try {
    const result = await handleRestoreUser({ userId });
    if (!result?.isSuccess) {
      return { isSuccess: false, message: result?.message || RESTORE_FAILURE_MESSAGE };
    }
    return result;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message || RESTORE_FAILURE_MESSAGE,
    };
  }
};

export const handleFetchCustomerAccounts = async (filter, limit) => {
  try {
    const thisFilter = {
      roles: ['USER'],
      includeDeleted: false,
    };
    Object.assign(thisFilter, filter);
    const users = await fetchUsers({ filter: thisFilter, limit });
    if (!_.isEmpty(users)) {
      return formatUsers(users);
    }
    return [];
  } catch (error) {
    return [];
  }
};
